import { CreateHeaderActionOptions } from '../../../../CIMSTableContext/types/actions/header'
import CreateEditFormItems from '../components/CreateEditFormItems'
import { CreateFormItemsValues } from '../components/CreateEditFormItems/types'
import {
  CreateCimsQuickLinkEntityOptions,
  Entity,
  MutationType,
  CimsQuickLinkEntity,
  Refetch,
} from '../types'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate<Create extends MutationType>({
  mutation,
  permission,
  refetch,
  entity,
  getLabel,
}: Entity &
  Refetch &
  CreateCimsQuickLinkEntityOptions<Create>): CreateHeaderActionOptions<CimsQuickLinkEntity> {
  const { projectId } = useProjectContext()
  const [create] = mutation({
    ...DefaultMutationHookOptions,
    onCompleted: (create) => simpleCreateNotification(getLabel(create).label),
  })
  return {
    permission,
    entity: 'Quick Link',
    modal: {
      type: 'simple',
      body: <CreateEditFormItems entity={entity} />,
      onOk: async (values: CreateFormItemsValues) => {
        await create({ variables: { input: { projectId, ...values } } })
        refetch()
      },
    },
  }
}
